/**
 * Render this module when the user doesn't have a G2MM profile.
 * Prompt the user to reserve a URL.
 */
define('setup/reserve-g2mm/editable/editable',['require','knockout','durandal/app','plugins/router','web-urls','api-access','api-access','lib/gotomeetme/suggest-url','mixpanel-helper','i18next'],function (require) {
    var ko = require('knockout');
    var app = require('durandal/app');
    var router = require('plugins/router');
    var webUrls = require('web-urls');
    var userApi = require('api-access').user;
    var goToMeetApi = require('api-access').gotomeet;
    var suggestUrl = require('lib/gotomeetme/suggest-url');
    var mixpanelHelper = require('mixpanel-helper');
    var i18n = require('i18next');

    return function () {
        var self = this;

        self.activate = function (activationData) {
            self.goToMeetMeUrl = webUrls.get('gotoMeetMeUrl');
            self.nextUrl = activationData.nextUrl;

            self.hasFocusUrl = ko.observable();
            self.hasUserTypedUrl = ko.observable(false);
            self.suggestedUrl = ko.observable();
            self.reservingG2mmProfile = ko.observable(false);
            self.isFreeTrialUser = ko.observable(false);
            self.showEditSubText = ko.computed(function () {
                return !self.hasUserTypedUrl();
            });

            self.isG2MMSchedulingTest = activationData.isG2MMSchedulingTest;
            self.chooseText = ko.observable(self.isG2MMSchedulingTest ? 'Your new meeting room' : i18n.t('setup.reserveG2mm.shareNameFreeTrial'));
            self.linkPlaceholder = ko.observable(self.isG2MMSchedulingTest ? '[your name]' : i18n.t('gotomeetme.profile.linkPlaceholder'));

            /*
             * instantUrl: tracks the input value immediately
             * delayedUrl: updates based on instantUrl at a rate limit.
             * Use delayedUrl as the accepted value, not instantUrl.
             */
            self.instantUrl = ko.observable(null);
            self.delayedUrl = ko.pureComputed(self.instantUrl).extend({
                rateLimit: {
                    method: 'notifyWhenChangesStop',
                    timeout: 400
                },
                required: true,
                urlRegex: true,
                takenG2mmUrl: true
            });

            /**
             * Record that the user has actively typed into the URL field.
             * Only show the URL success message if that is the case.
             */
            self.delayedUrl.subscribe(function () {
                if (self.suggestedUrl() && self.delayedUrl()) {
                    if (self.suggestedUrl() !== self.delayedUrl()) {
                        self.hasUserTypedUrl(true);
                    }
                }
            });

            self.isReserveEnabled = ko.pureComputed(function () {
                return self.delayedUrl.isValid() && !self.delayedUrl.isValidating();
            });

            self.showSuccessMessage = ko.pureComputed(function () {
                return self.delayedUrl.isValid() && !self.delayedUrl.isValidating() && self.hasUserTypedUrl();
            });

            userApi.updateSettings({gotomeetmeOnboardingViewed: true});

            userApi.me()
                .then(function (userMe) {
                    suggestUrl(userMe.firstName, userMe.lastName).then(function (url) {
                        self.instantUrl(url);
                        self.suggestedUrl(url);
                    });
                });
        };

        self.compositionComplete = function () {
            // Observable that dictates focus of the URL form. Set the focus on page composition.
            self.hasFocusUrl(true);
        };

        self.reserve = function () {
            self.reservingG2mmProfile(true);

            mixpanelHelper.track('Reserve G2MM URL');

            userApi.me()
                .then(function (userMe) {
                    var profileInfo = {
                        profileId: self.delayedUrl(),
                        userKey: userMe.key,
                        roomName: userMe.firstName + '\'s Meeting',
                        name: userMe.firstName + ' ' + userMe.lastName
                    };

                    goToMeetApi.create(profileInfo)
                        .then(function () {
                            self.reservingG2mmProfile(false);
                            userApi.updateSettings({onboardingCompleted: true}).then(function () {
                                window.mixpanel.register({onboardingCompleted: true});
                                app.trigger('g2mmUrl:reserved');
                                if (self.nextUrl) {
                                    router.navigate(self.nextUrl);
                                } else {
                                    window.location.href = self.goToMeetMeUrl + '/' + profileInfo.profileId;
                                }
                            });
                        })
                        .fail(function () {
                            // at this point any error we assume we can't go to g2mm
                            // nextUrl is empty or 2nd page, so just use that
                            router.navigate('reserve');
                        });
                });
        };
    };
});

